export default __webpack_public_path__ + "images/smile_scan_star_white.559573dcfb677e6fee8617b878bc32df.svg";